import { render, staticRenderFns } from "./SidebarToggleButton.vue?vue&type=template&id=1d13b2e0&scoped=true"
import script from "./SidebarToggleButton.vue?vue&type=script&lang=js"
export * from "./SidebarToggleButton.vue?vue&type=script&lang=js"
import style0 from "./SidebarToggleButton.vue?vue&type=style&index=0&id=1d13b2e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d13b2e0",
  null
  
)

export default component.exports